import { render, staticRenderFns } from "./HomeNewsBox.vue?vue&type=template&id=76914e9c&scoped=true&"
import script from "./HomeNewsBox.vue?vue&type=script&lang=js&"
export * from "./HomeNewsBox.vue?vue&type=script&lang=js&"
import style0 from "./HomeNewsBox.vue?vue&type=style&index=0&id=76914e9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76914e9c",
  null
  
)

export default component.exports